import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('certificationStatesCell');

    return {
        ADD_CERTIFICATION: t('addCertification'),
        ADD_CERTIFICATION_LABEL: (memberName: string) =>
            t('addCertificationLabel', { memberName }),
        EXPIRED_TOOLTIP: (certificationNumber: string, expirationDate: string) =>
            t('expiredTooltip', { certificationNumber, expirationDate }),
        EXPIRES_IN_DAY_TOOLTIP: (certificationNumber: string) =>
            t('expiresInDayTooltip', { certificationNumber }),
        EXPIRES_IN_DAYS_TOOLTIP: (certificationNumber: string, dayCount: number) =>
            t('expiresInDaysTooltip', { certificationNumber, dayCount }),
        EXPIRES_TODAY_TOOLTIP: (certificationNumber: string) =>
            t('expiresTodayTooltip', { certificationNumber }),
        HIDDEN_CERTIFICATIONS_TOOLTIP: (states: string) =>
            t('hiddenCertificationsTooltip', { states }),
        NO_EXPIRATION_TOOLTIP: (certificationNumber: string) =>
            t('noExpirationTooltip', { certificationNumber }),
        VALID_THROUGH_TOOLTIP: (certificationNumber: string, expirationDate: string) =>
            t('validThroughTooltip', { certificationNumber, expirationDate })
    };
};

export default useTranslation;
